module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"text":"There are currently no active Job templates. Please click on the \u0027Add new template\u0027 button to create a new one. Some job templates have been archived due to recent SOC code updates by the Home Office; you can view them in the \u0027Archived\u0027 tab."}}')
  delete Component.options._Ctor
}
